import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Запрашиваемый файл не найден ")
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FailureBanner = _resolveComponent("FailureBanner")!
  const _component_EntityView = _resolveComponent("EntityView")!
  const _component_EntityLink = _resolveComponent("EntityLink")!
  const _component_EntityList = _resolveComponent("EntityList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.page)
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          class: _normalizeClass(_ctx.$style.spinner)
        }, null, 8, ["class"]))
      : (_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_FailureBanner, {
            key: 1,
            class: _normalizeClass(_ctx.$style.notFound)
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_ctx.$style.content)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.current)
            }, [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.$style.title),
                textContent: _toDisplayString(_ctx.file.name)
              }, null, 10, _hoisted_2),
              _createVNode(_component_EntityView, {
                class: _normalizeClass(_ctx.$style.view),
                entity: _ctx.file
              }, null, 8, ["class", "entity"])
            ], 2),
            (_ctx.neighbourFiles.length > 1)
              ? (_openBlock(), _createBlock(_component_EntityList, {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.neighbour),
                  entities: _ctx.neighbourFiles
                }, {
                  default: _withCtx(({ entity }) => [
                    _createVNode(_component_EntityLink, {
                      key: entity.id,
                      class: _normalizeClass([_ctx.$style.item, { [_ctx.$style.active]: entity.id === _ctx.file.id }]),
                      entity: entity
                    }, null, 8, ["class", "entity"])
                  ]),
                  _: 1
                }, 8, ["class", "entities"]))
              : _createCommentVNode("", true)
          ], 2))
  ], 2))
}